export enum RecordTypeEnum {
  REAL = 'Real',
  TEST = 'Test',
  ALL = 'All',
}

export interface RecordTypeState {
  selected: RecordTypeEnum;
}
